var map = {
	"./Charly.png": 25,
	"./Freddie.png": 62,
	"./Jennifer.png": 63,
	"./Katrine.png": 64,
	"./Scarlett.png": 65,
	"./Sophia.png": 66,
	"./Timmy.png": 67,
	"./Woody.png": 68
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24;